export const CALENDARS_TAG_EVENTS = {
  CREATED_CALENDAR: 'CalendarAdded',
  DELETED_CALENDAR: 'CalendarDeleted',
};
